//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class FamilyPayableDisplayItem extends ItemBase {
    AmountDue: number | null = null;
    LateFee: number | null = null;
    InvoiceGUID: string | null = null;

    constructor(initializer?: Partial<FamilyPayableDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "FamilyPayableDisplayItem";
}
